var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center my-5"},[_c('b-spinner',{staticClass:"justify-content-center",attrs:{"variant":"primary","type":"grow"}}),_c('span',{staticClass:"ml-5 h4 text-secondary font-weight-bold"},[_vm._v("Loading...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }